import { apiRequest } from '@/core';
import { type CreateIncidentPayload } from '@/slices/events/types';

export const createIncidentRequest = async (data: CreateIncidentPayload) =>
  apiRequest<void>({
    endpoint: 'api/incidents',
    body: data,
  });
